import {CheckCircle2Icon, CircleAlertIcon} from "lucide-react";
import {Badge} from "@/components/ui/badge.tsx";
import {cn} from "@/lib/utils.ts";

const backupStates = {
    INITIALIZED: {label: "Wird erstellt", className: "border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-300"},
    CREATED: {label: "Erstellt", className: "border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"},
    UPLOADED: {label: "Hochgeladen", className: "border-blue-500/30 bg-blue-500/10 text-blue-700 dark:text-blue-300"},
    FAILED: {label: "Fehlgeschlagen", className: "border-destructive/30 bg-destructive/10 text-destructive"},
} as const;

function getBackupState(state: string) {
    return backupStates[state as keyof typeof backupStates] ?? {label: state, className: ""};
}

export function BackupStateBadge({state, withIcon = false, className}: {
    state: string;
    withIcon?: boolean;
    className?: string;
}) {
    const presentation = getBackupState(state);
    return <Badge variant="outline" className={cn(presentation.className, className)}>
        {withIcon && (state === "FAILED" ? <CircleAlertIcon/> : <CheckCircle2Icon/>)}
        {presentation.label}
    </Badge>;
}
